import {Grid, Typography,Tooltip,IconButton,Switch, FormControlLabel} from '@material-ui/core';
import {getHeadingCount,loadSkeleton,TOPIC_UTIL} from '../../utility';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function TopicBrief({showUnused,setShowUnused,viewHeadings,topics}){

    const css = `
        .brief-topic .brief-topic-switch-label span{
            font-size: 12px !important;
        }
    `;

    return(
        <Grid className="brief-topic" container xs="12"  direction="row" spacing={1} style={{backgroundColor:'white'}}>
            <style>{css}</style>
             <Grid xs="12" item style={{textAlign:'center'}} >
             </Grid>
                <Grid item xs="12"  direction="column" spacing={1} style={{margin:'0rem 0rem 0rem 0rem',background:'white'}}>
                    <div style={{paddingLeft: '1rem', marginBottom: '8px'}}>
                        <Typography variant="h6" color="primary" style={{fontWeight:'bold'}} gutterBottom>{TOPIC_UTIL.HEADER}</Typography>
                        <FormControlLabel 
                            value="Show Only Unused"
                            className="brief-topic-switch-label"
                            control={<Switch
                                color="primary"
                                checked={showUnused}
                                onChange={()=>setShowUnused(!showUnused)}
                                />}
                            label="Show Only Unused"
                            labelPlacement="end"
                            gutterBottom
                        />
                    </div>
                    {(topics.length > 0)? 
                        (topics).map((topic,index) => {
                            if(showUnused){
                                if(topic.covered){
                                    return;
                                }
                            }
                            return (
                                <Grid container xs="12" alignItems="center" style={{padding:'0.5rem 1rem', cursor: 'pointer', backgroundColor: (topic.covered ? 'rgb(213 233 214)' : 'inherit')}}>
                                    <Tooltip title={`Click to view Examples`} arrow style={{float:'right'}}>
                                        <Grid item xs="10" onClick={() => viewHeadings(topic)}>
                                            <Typography variant="subtitle1" style={{float:'left',width:'100%',fontWeight:'700',color:'#3e4b5b'}}>
                                                {topic.name}
                                            </Typography>
                                            <Typography variant="caption" style={{float:'left',color:'grey'}}>
                                                {TOPIC_UTIL.SOURCES_TEXT_1} <Typography variant="caption" style={{fontStyle:'italic'}}>{topic.summary && topic.summary.length}</Typography> {TOPIC_UTIL.SOURCES_TEXT_2}
                                            </Typography>
                                        </Grid>
                                    </Tooltip>
                                    <Grid item xs="2">
                                        {getHeadingCount(topic) > 0  && <Tooltip title={`used in ${getHeadingCount(topic)} Headings`} arrow style={{float:'right'}}>
                                            <IconButton aria-label="Headings Topic" onClick={() => viewHeadings(topic)} style={{fontSize: '14px', paddingTop: '0'}}>
                                                <FontAwesomeIcon icon="heading" />
                                            </IconButton>
                                        </Tooltip>}
                                    </Grid>
                                </Grid>
                            );
                        })
                    : 
                    loadSkeleton('text')
                    }
            </Grid>
        </Grid>
    );

}

export default TopicBrief;